import React, { useEffect, useState } from "react";
import SoftButton from "components/SoftButton";
import { Icon } from "@mui/material";

const InstallPWA = () => {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setSupportsPWA(true);
      setPromptInstall(e);
    };
    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("transitionend", handler);
  }, []);

  const onClick = (evt) => {
    evt.preventDefault();
    if (!promptInstall) {
      return;
    }
    promptInstall.prompt();
  };
  if (!supportsPWA) {
    return null;
  }
  return (
    <SoftButton id="setup_button" onClick={onClick} color="primary" circular>
      Instalar APP&nbsp;
      <Icon>download</Icon>
    </SoftButton>
  );
};

export default InstallPWA;
